import events from '~/modules/game-events/game-events';
import { useEventListenerSelector } from '~/modules/game-events/hooks';
import PlayersManager from '~/modules/players/players-manager';
import { MicSetupPreferenceSetting, useSettingValue } from '~/routes/settings/settings-state';

/**
 * What the main menu says under Setup microphones - the first thing a new room has to do, on a
 * button otherwise indistinguishable from Settings.
 *
 * "Set up" is the stored preference, the same test `game-settings.tsx` makes before it will let a
 * song start: `skip` is a room that was asked and said no, not a room that is ready. The count is
 * the slots that ended up with a real device behind them, since a slot nobody claimed keeps the
 * `Dummy` source it was created with - so a room that picked "phones" but has none connected yet
 * reads "none yet" rather than claiming two.
 */
export default function useMicSetupSummary() {
  const [storedPreference] = useSettingValue(MicSetupPreferenceSetting);
  const inputs = useEventListenerSelector([events.playerInputChanged, events.playerAdded, events.playerRemoved], () =>
    PlayersManager.getInputs(),
  );

  const configured = !!storedPreference && storedPreference !== 'skip';
  const ready = inputs.filter((input) => input.source !== 'Dummy').length;

  return configured && ready > 0 ? `${ready} ready` : 'none yet';
}
